import * as React from "react";
import {
  List,
  DataTable,
  ReferenceInput,
  FunctionField,
  AutocompleteInput,
  DateField,
  usePermissions,
  ReferenceField,
  ChipField,
} from "react-admin";
import { RESTAURANT_TYPES } from "../enums/RestaurantTypes";
import { ROLE_TYPES } from "../enums/Roles";
import { getReviewStatusName } from "../utils/ReviewUtils";

const COMMENT_LENGTH = 50;

const ReviewFilter = () => {
  const { permissions } = usePermissions();

  return [
    ...(permissions === ROLE_TYPES.ADMIN
      ? [
          <ReferenceInput
            source="restaurant"
            reference="restaurants"
            perPage={10}
            filter={{
              active: true,
              type: RESTAURANT_TYPES.REGULAR,
            }}
            label="Local"
            alwaysOn={true}
          >
            <AutocompleteInput
              filterToQuery={(searchText) => ({ name: searchText })}
              label="Local"
              optionText="name"
            />
          </ReferenceInput>,
        ]
      : []),
  ];
};

const ReviewList = () => {
  const { permissions } = usePermissions();

  return (
    <List
      title="Calificaciones"
      filters={ReviewFilter()}
      sort={{ field: "createdAt", order: "DESC" }}
      exporter={false}
    >
      <DataTable rowClick="show" bulkActionButtons={false}>
        <DataTable.Col source="user" label="Usuario">
          <FunctionField
            source="user"
            label="Usuario"
            render={(record) =>
              `${record?.user?.firstName || ""} ${
                record?.user?.lastName || ""
              }` || "-"
            }
          />
        </DataTable.Col>
        <DataTable.Col source="purchase" label="Compra">
          <ReferenceField
            label="Compra"
            reference="purchases"
            source="purchase"
            link={false}
            emptyText="-"
          >
            <ChipField source="productData.name" label="Compra" />
          </ReferenceField>
        </DataTable.Col>
        <DataTable.Col source="coupon" label="Canje">
          <ReferenceField
            label="Canje"
            reference="coupons"
            source="coupon"
            link={false}
            emptyText="-"
          >
            <ChipField source="redeemedCoupon.product.name" label="Canje" />
          </ReferenceField>
        </DataTable.Col>
        {permissions === ROLE_TYPES.ADMIN && (
          <DataTable.Col source="restaurant.name" label="Local">
            <ChipField source="restaurant.name" label="Local" />
          </DataTable.Col>
        )}
        <DataTable.Col source="rating" label="Calificación">
          <FunctionField
            source="rating"
            label="Calificación"
            render={(record) => {
              const stars = Array.from(Array(record?.rating)).map((r) => "⭐️");
              return `${stars?.join("")} (${record?.rating})`;
            }}
          />
        </DataTable.Col>
        <DataTable.Col source="comment" label="Comentarios">
          <FunctionField
            source="comment"
            render={(record) =>
              record.comment?.length > COMMENT_LENGTH
                ? record.comment?.substring(0, COMMENT_LENGTH) + "..."
                : record.comment
            }
            label="Comentarios"
          />
        </DataTable.Col>
        <DataTable.Col source="status" label="Estado">
          <FunctionField
            source="status"
            label="Estado"
            render={(record) => getReviewStatusName(record.status)}
          />
        </DataTable.Col>
        <DataTable.Col source="createdAt" label="Fecha">
          <DateField
            source="createdAt"
            label="Fecha"
            showTime={true}
            emptyText="-"
          />
        </DataTable.Col>
      </DataTable>
    </List>
  );
};

export default ReviewList;
